const leadershipData = {
  title: "The Starfleet",
  paragraph:
    "“ We bring it all together to create meaningful business outcome ”",
  leaderName: "Tammy Soares",
  designation: "Product Launch President",
  linkedinImg: "./LeaderShipImages/tammyLinkedin.png",
  linkedinUrl: "https://www.linkedin.com/in/tdsoares",
  vectorClass: "vector_after_linkedin",
  leaderImage: "./LeaderShipImages/tammy.png",
};

const otherLeaders = [
  {
    profileSectionClass: "firstProfileSection",
    imageSrc: "./LeaderShipImages/tom_profile.png",
    altText: "Tom Kotlarek",
    placeholderText:
      "SVP of Global Delivery and Operations at Launch and brings in leadership experience from companies like NASA and DreamWorks",
    name: "Tom Kotlarek",
    designation: "Senior Vice President",
    linkedinImg: "./LeaderShipImages/linkedinIcon.png",
    linkedinUrl: "https://www.linkedin.com/in/tom-kotlarek",
    playButtonImg: "./LeaderShipImages/PlayIcon.png",
    vectorClass: "vector_N2",
  },
  {
    profileSectionClass: "SecondProfileSection",
    imageSrc: "./LeaderShipImages/nate_profile.png",
    altText: "Nate Spillson",
    placeholderText:
      "Launch by NTT DATA’s SVP of Engineering, AI advocate and author of the Frictionless Enterprise book",
    name: "Nate Spillson",
    designation: "Senior Vice President",
    linkedinImg: "./LeaderShipImages/linkedinIcon.png",
    linkedinUrl: "https://www.linkedin.com/in/natespillson",
    playButtonImg: "./LeaderShipImages/PlayIcon.png",
    vectorClass: "vector_N2",
  },
];

export { leadershipData, otherLeaders };
